module.exports = __webpack_public_path__ + "static/media/electric.187531bf.jpg";